export default {
    formSection: {
        "borderRadius": "10px",
        "boxShadow": "0 1px 80px #03172B1C"
    },
    button: {
        "backgroundColor": "#D672A9",
        "borderRadius": "36px",
    }
}